import { styled } from "@mui/material";

interface ComponentProps {
    handleUpdate: () => void;
    handleDelete: () => void;
}

const ScoreTypeOptions: React.FC<ComponentProps> = ({ handleDelete, handleUpdate}) => {
    return (
        <>
            <StyledCardText onClick={handleUpdate}>Update</StyledCardText>
            {/* <StyledCardText onClick={handleDelete}>Delete</StyledCardText> */}
        </>
    )
}

export default ScoreTypeOptions;

const StyledCardText = styled('button')`
    cursor: pointer;
    padding-inline-start: 1.2rem;
    padding-block: 0.6rem;
    font-size: 1rem;
    color: #232323;
    border: none;
    background-color: transparent;
    text-align: left;
    &:hover {
        background-color: #f1f1f1;
    }
    
`